import { TableCell, TableRow } from "@/components/ui/table"
import { Toggle } from "@/components/ui/toggle"
import { cn } from "@/lib/utils"
import { CircleIcon } from "@radix-ui/react-icons"


export type OptionValue = {
  label: string
  value: number
} | null

export type QuestionOptions = {
  hyper: OptionValue
  hypo: OptionValue
  dyst: OptionValue
  anergie: OptionValue
  synd: OptionValue
}

export type Question = {
  id: string
  label: string
  type?: "matrix" | "text_group" | "checkbox_group" | "textarea"
  options?: QuestionOptions | string[]
  fields?: string[]
}

interface QuestionRowProps {
  question: Question
  answers: Record<string, string[]>
  onToggle: (questionId: string, column: string) => void
}

const COLUMNS = ["hyper", "hypo", "dyst", "anergie", "synd"] as const

export function QuestionRow({ question, answers, onToggle }: QuestionRowProps) {
  const currentAnswers = answers[question.id] || []

  return (
    <TableRow>
      <TableCell className="font-medium w-1/3">{question.label}</TableCell>
      {COLUMNS.map((col) => {
        const options = question.options as QuestionOptions
        const option = options?.[col]
        const isActive = currentAnswers.includes(col)

        return (
          <TableCell key={col} className="text-center p-1">
            {option ? (
              <Toggle
                pressed={isActive}
                onPressedChange={() => onToggle(question.id, col)}
                className={cn(
                  "w-12 h-10 font-bold transition-all duration-200 ease-in-out cursor-pointer data-[state=on]:bg-transparent", isActive ? "hover:opacity-90 scale-110 " :  "hover:scale-110"
                )}
              >
                {isActive ? (
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={cn(option.value === 2 ? "text-red-500" : "text-primary")}
                  >
                    <circle cx="7.5" cy="7.5" r="7" fill="currentColor" />
                  </svg>
                ) : (
                  <CircleIcon className="text-muted-foreground" />
                )}
              </Toggle>
            ) : (
              <div className="w-12 h-10 mx-auto" />
            )}
          </TableCell>
        )
      })}
    </TableRow>
  )
}


